import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-view-contacts',
  templateUrl: './view-contacts.component.html',
  styleUrls: ['./view-contacts.component.css']
})
export class ViewContactsComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
